<div class="sidebar-wrap" style="background:#fff; border:1px solid #e8edf2; border-radius:12px; overflow:hidden;">
  <div *ngIf="false" style="padding:12px 16px; border-bottom:1px solid #f1f5f9; background:#fafafa;">
    <span style="font-size:13px; font-weight:600; color:#1e293b;">
      <i class="pi pi-sliders-h" style="color:#64748b; margin-right:6px;"></i>Filters
    </span>
  </div>

  <div *ngIf="false"
    style="padding:10px 12px; border-bottom:1px solid #f1f5f9; display:flex; flex-wrap:wrap; gap:6px; align-items:center;">
    <ng-container *ngFor="let filter of appliedFilters">
      <p-chip *ngIf="filter.value !== undefined && filter.value !== null" [label]="getFilterValue(filter)"
        [removable]="true" styleClass="chips" (onRemove)="removeFilter(filter)">
      </p-chip>
    </ng-container>
  </div>

  <div *ngIf="activeTab === 'programmes'" class="programmes-filters">
    
    <h3 class="font-bold text-2xl m-0 mb-4" style="color: #000; font-family: 'Circular Std', sans-serif;">Filter</h3>
    
    <div class="filter-section">
      <div class="filter-header">LOCATION</div>
      <div class="filter-content">
        <div><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">Country</label>
          <p-dropdown [options]="countries" [(ngModel)]="selectedCountry" optionLabel="name" optionValue="countryCode"
            [filter]="true" [showClear]="true" appendTo="body" (onChange)="onCountrySelection($event); searchInstitutes()"
            placeholder="Select Country" styleClass="w-full" />
        </div>
        <div class="mt-2"><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">State / Province</label>
          <p-dropdown [options]="provinces" [(ngModel)]="selectedProvince" optionLabel="name" optionValue="id"
            [filter]="true" [showClear]="true" appendTo="body" (onChange)="onProvinceSelection($event); searchInstitutes()"
            placeholder="Select State" styleClass="w-full" />
        </div>
        <div class="mt-2"><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">City / Town</label>
          <p-dropdown [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" optionValue="name"
            [filter]="true" [showClear]="true" appendTo="body" placeholder="Select City" styleClass="w-full"
            [virtualScroll]="true" [itemSize]="38" (onChange)="searchInstitutes()" />
        </div>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-header">TYPES</div>
      <div class="filter-content">
        <div class="types-toggle">
          <button (click)="setDaType('All')" class="types-pill" [class.active]="daType === 'All'">
            <span>All</span>
            <span class="count-badge" *ngIf="allUniversitiesCount > 0">{{ allUniversitiesCount }}</span>
          </button>
          <button (click)="setDaType('India')" class="types-pill" [class.active]="daType === 'India'">
            <span>Direct Apply India</span>
          </button>
          <button (click)="setDaType('Abroad')" class="types-pill" [class.active]="daType === 'Abroad'">
            <span>Direct Apply Abroad</span>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-header">DEGREE LEVEL</div>
      <div class="filter-content">
        <div class="flex flex-wrap gap-2">
          <button *ngFor="let lvl of courseLevels" 
                  (click)="toggleCourseLevelValue(lvl.value)"
                  class="p-link pill-btn" [class.active]="selectedCourseLevel === lvl.value">
            {{ lvl.name }}
          </button>
        </div>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-header">STUDY MODE</div>
      <div class="filter-content">
        <div class="flex flex-wrap gap-2">
          <button *ngFor="let mode of ['Full-Time', 'Part-Time', 'Online', 'Hybrid']" 
                  (click)="toggleStudyMode(mode)"
                  class="p-link pill-btn" [class.active]="selectedStudyModes.includes(mode)">
            {{ mode }}
          </button>
        </div>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-header">DURATION</div>
      <div class="filter-content">
        <div class="flex flex-wrap gap-2">
          <button *ngFor="let dur of ['1 year', '2 years', '3+ years']" 
                  (click)="toggleDuration(dur)"
                  class="p-link pill-btn" [class.active]="selectedDurations.includes(dur)">
            {{ dur }}
          </button>
        </div>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-header">DEADLINE</div>
      <div class="filter-content">
        <p-dropdown [options]="applicationStatusOptions" [(ngModel)]="selectedApplicationStatus"
          styleClass="w-full" [showClear]="true" optionLabel="name" optionValue="value" appendTo="body"
          placeholder="Select Status" (onChange)="searchInstitutes()">
        </p-dropdown>
      </div>
    </div>

    <div class="filter-section">
      <div class="filter-header">TUITION (PER YEAR)</div>
      <div class="filter-content">
        <div class="mb-3"><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">Select Currency</label>
          <p-dropdown [options]="currencies" [(ngModel)]="selectedCurrency" optionLabel="label" optionValue="value"
            styleClass="w-full" placeholder="Select Currency" (onChange)="onCurrencyChange()" appendTo="body" />
        </div>
        <div>
          <label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">
            Tuition Fees ({{ getCurrencySymbol() }}{{ tuitionFeesRange[0] | number }} –
            {{ getCurrencySymbol() }}{{ tuitionFeesRange[1] | number }})
          </label>
          <div style="padding-top:8px;">
            <p-slider [(ngModel)]="tuitionFeesRange" [range]="true" [min]="0" [max]="getMaxForCurrency()"
              [step]="getStepForCurrency()" class="w-full" (onChange)="searchInstitutes()" />
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="activeTab !== 'programmes'" class="programmes-filters">
    <h3 class="font-bold text-2xl m-0 mb-4" style="color: #000; font-family: 'Circular Std', sans-serif;">Filter</h3>

    <!-- 1. TYPES -->
    <div class="filter-section">
      <div class="filter-header">TYPES</div>
      <div class="filter-content">
        <div class="types-toggle">
          <button (click)="setDaType('All')" class="types-pill" [class.active]="daType === 'All'">
            <span>All</span>
            <span class="count-badge" *ngIf="allUniversitiesCount > 0">{{ allUniversitiesCount }}</span>
          </button>
          <button (click)="setDaType('India')" class="types-pill" [class.active]="daType === 'India'">
            <span>Direct Apply India</span>
          </button>
          <button (click)="setDaType('Abroad')" class="types-pill" [class.active]="daType === 'Abroad'">
            <span>Direct Apply Abroad</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 2. COURSE (Degree Level) -->
    <div class="filter-section">
      <div class="filter-header">COURSE</div>
      <div class="filter-content">
        <div class="flex flex-wrap gap-2">
          <button *ngFor="let lvl of courseLevels" 
                  (click)="toggleCourseLevelValue(lvl.value)"
                  class="p-link pill-btn" [class.active]="selectedCourseLevel === lvl.value">
            {{ lvl.name }}
          </button>
        </div>
      </div>
    </div>

    <!-- 3. LOCATION (Dropdowns) -->
    <div class="filter-section">
      <div class="filter-header">LOCATION</div>
      <div class="filter-content">
        <div><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">Country</label>
          <p-dropdown [options]="countries" [(ngModel)]="selectedCountry" optionLabel="name" optionValue="countryCode"
            [filter]="true" [showClear]="true" appendTo="body" (onChange)="onCountrySelection($event); searchInstitutes()"
            placeholder="Select Country" styleClass="w-full" />
        </div>
        <div class="mt-2"><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">State / Province</label>
          <p-dropdown [options]="provinces" [(ngModel)]="selectedProvince" optionLabel="name" optionValue="id"
            [filter]="true" [showClear]="true" appendTo="body" (onChange)="onProvinceSelection($event); searchInstitutes()"
            placeholder="Select State" styleClass="w-full" />
        </div>
        <div class="mt-2"><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">City / Town</label>
          <p-dropdown [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" optionValue="name"
            [filter]="true" [showClear]="true" appendTo="body" placeholder="Select City" styleClass="w-full"
            [virtualScroll]="true" [itemSize]="38" (onChange)="searchInstitutes()" />
        </div>
      </div>
    </div>

    <!-- 4. MAJORS (Dropdown) -->
    <div class="filter-section">
      <div class="filter-header">MAJORS</div>
      <div class="filter-content">
        <p-dropdown [options]="majors" [(ngModel)]="major_program" styleClass="w-full"
          [showClear]="true" optionLabel="name" optionValue="value" [filter]="true" filterBy="name"
          appendTo="body" placeholder="Select Major" (onChange)="searchInstitutes()">
          <ng-template pTemplate="selectedItem" let-selectedOption>
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-major pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ major.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>




    <!-- 7. FINANCE -->
    <div class="filter-section">
      <div class="filter-header">FINANCE (PER YEAR)</div>
      <div class="filter-content">
        <div class="mb-3"><label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">Select Currency</label>
          <p-dropdown [options]="currencies" [(ngModel)]="selectedCurrency" optionLabel="label" optionValue="value"
            styleClass="w-full" placeholder="Select Currency" (onChange)="onCurrencyChange(); searchInstitutes()" appendTo="body" />
        </div>
        <div>
          <label class="filter-label" style="font-size: 12px; font-weight: 500; color: #64748b; margin-bottom: 4px; display: block;">
            Tuition Fees ({{ getCurrencySymbol() }}{{ tuitionFeesRange[0] | number }} –
            {{ getCurrencySymbol() }}{{ tuitionFeesRange[1] | number }})
          </label>
          <div style="padding-top:8px;">
            <p-slider [(ngModel)]="tuitionFeesRange" [range]="true" [min]="0" [max]="getMaxForCurrency()"
              [step]="getStepForCurrency()" class="w-full" (onChange)="searchInstitutes()" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="false">
    <ng-container *ngFor="let f of filterList">

      <div (click)="toggleSidebarFilter(f.key)"
        style="display:flex; align-items:center; justify-content:space-between; padding:11px 16px; cursor:pointer; border-bottom:1px solid #f1f5f9; transition: background 0.15s;"
        [style.background]="activeFilter === f.key ? '#eff6ff' : '#fff'"
        [style.border-left]="activeFilter === f.key ? '3px solid #CDD12A' : '3px solid transparent'">
        <span style="display:flex; align-items:center; gap:10px; font-size:13px;"
          [style.color]="activeFilter === f.key ? '#1d4ed8' : '#334155'"
          [style.font-weight]="activeFilter === f.key ? '600' : '400'">
          <i class="pi" [ngClass]="f.icon" style="font-size:13px; width:15px;"
            [style.color]="activeFilter === f.key ? '#CDD12A' : '#94a3b8'"></i>
          {{ f.key }}
        </span>
        <i class="pi" [ngClass]="activeFilter === f.key ? 'pi-chevron-up' : 'pi-chevron-down'" style="font-size:11px;"
          [style.color]="activeFilter === f.key ? '#2563eb' : '#94a3b8'"></i>
      </div>

      <div *ngIf="activeFilter === f.key" style="padding:12px 14px; background:#f8fafc; border-bottom:1px solid #e2e8f0;
              display:flex; flex-direction:column; gap:10px;">

        <ng-container *ngIf="activeFilter === searchFilters.location">
          <div><label class="filter-label">Country</label>
            <p-dropdown [options]="countries" [(ngModel)]="selectedCountry" optionLabel="name" optionValue="countryCode"
              [filter]="true" [showClear]="true" appendTo="body" (onChange)="onCountrySelection($event)"
              placeholder="Select Country" styleClass="w-full" />
          </div>
          <div><label class="filter-label">State / Province</label>
            <p-dropdown [options]="provinces" [(ngModel)]="selectedProvince" optionLabel="name" optionValue="id"
              [filter]="true" [showClear]="true" appendTo="body" (onChange)="onProvinceSelection($event)"
              placeholder="Select State" styleClass="w-full" />
          </div>
          <div><label class="filter-label">City / Town</label>
            <p-dropdown [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" optionValue="name"
              [filter]="true" [showClear]="true" appendTo="body" placeholder="Select City" styleClass="w-full"
              [virtualScroll]="true" [itemSize]="38" />
          </div>
          <div><label class="filter-label">Distance from Home ({{distanceFromHome}} km)</label>
            <p-slider [(ngModel)]="distanceFromHome" [min]="0" [max]="500" class="w-full" />
          </div>
          <div><label class="filter-label">Degree of Urbanisation</label>
            <p-dropdown [options]="campus" [(ngModel)]="selectedDegreeOfUrbanisation" optionLabel="name"
              optionValue="value" styleClass="w-full" placeholder="Select Urbanisation" appendTo="body" />
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.types">
          <div class="flex flex-wrap gap-2 mb-3">
            <button (click)="setDaType('All')"
                    class="p-link pill-btn" [class.active]="daType === 'All'">
              All
              <span class="count-badge" *ngIf="allUniversitiesCount > 0">{{ allUniversitiesCount }}</span>
            </button>
            <button (click)="setDaType('India')"
                    class="p-link pill-btn" [class.active]="daType === 'India'">
              Direct Apply India
            </button>
            <button (click)="setDaType('Abroad')"
                    class="p-link pill-btn" [class.active]="daType === 'Abroad'">
              Direct Apply Abroad
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.course">
          <div><label class="filter-label">Course Level</label>
            <p-dropdown [options]="courseLevels" [(ngModel)]="selectedCourseLevel" styleClass="w-full"
              [showClear]="true" optionLabel="name" optionValue="value" [filter]="true" filterBy="name"
              appendTo="body" placeholder="Select Course Level">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-level pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ level.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.studyMode">
          <div class="flex flex-wrap gap-2 mb-3">
            <button *ngFor="let mode of ['Full-Time', 'Part-Time', 'Online', 'Hybrid']" 
                    (click)="toggleStudyMode(mode)"
                    class="p-link pill-btn" [class.active]="selectedStudyModes.includes(mode)">
              {{ mode }}
            </button>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.duration">
          <div class="flex flex-wrap gap-2 mb-3">
            <button *ngFor="let dur of ['1 year', '2 years', '3+ years']" 
                    (click)="toggleDuration(dur)"
                    class="p-link pill-btn" [class.active]="selectedDurations.includes(dur)">
              {{ dur }}
            </button>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.majors">
          <div><label class="filter-label">Major / Program</label>
            <p-dropdown [options]="majors" [(ngModel)]="major_program" styleClass="w-full"
              [showClear]="true" optionLabel="name" optionValue="value" [filter]="true" filterBy="name"
              appendTo="body" placeholder="Select Major">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-major pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ major.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.universityType">
          <div><label class="filter-label">University Type</label>
            <p-dropdown [options]="universityTypeOptions" [(ngModel)]="selectedUniversityType" styleClass="w-full"
              [showClear]="true" optionLabel="name" optionValue="value" placeholder="Select" appendTo="body" />
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.facilities">
          <div class="checkbox-group">
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedSports" [binary]="true" inputId="cb-sports" />
              <label for="cb-sports" class="checkbox-label">Sports Facilities</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedPool" [binary]="true" inputId="cb-pool" />
              <label for="cb-pool" class="checkbox-label">Swimming Pool</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedGym" [binary]="true" inputId="cb-gym" />
              <label for="cb-gym" class="checkbox-label">Gym</label>
            </div>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.finance">
          <div><label class="filter-label">Select Currency</label>
            <p-dropdown [options]="currencies" [(ngModel)]="selectedCurrency" optionLabel="label" optionValue="value"
              styleClass="w-full" placeholder="Select Currency" (onChange)="onCurrencyChange()" appendTo="body" />
          </div>
          <div>
            <label class="filter-label">
              Tuition Fees ({{ getCurrencySymbol() }}{{ tuitionFeesRange[0] | number }} –
              {{ getCurrencySymbol() }}{{ tuitionFeesRange[1] | number }})
            </label>
            <div style="padding-top:8px;">
              <p-slider [(ngModel)]="tuitionFeesRange" [range]="true" [min]="0" [max]="getMaxForCurrency()"
                [step]="getStepForCurrency()" class="w-full" />
            </div>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.activities">
          <div class="checkbox-group">
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedCulturalFestivals" [binary]="true" inputId="cb-cultural" />
              <label for="cb-cultural" class="checkbox-label">Cultural Festivals</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedTechFests" [binary]="true" inputId="cb-techfest" />
              <label for="cb-techfest" class="checkbox-label">Tech Fests</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedCollegeFests" [binary]="true" inputId="cb-collegefest" />
              <label for="cb-collegefest" class="checkbox-label">College Fests</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedClubsAndSocieties" [binary]="true" inputId="cb-clubs" />
              <label for="cb-clubs" class="checkbox-label">Clubs and Societies</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedTech" [binary]="true" inputId="cb-tech" />
              <label for="cb-tech" class="checkbox-label">Tech</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedActivityArts" [binary]="true" inputId="cb-arts" />
              <label for="cb-arts" class="checkbox-label">Arts</label>
            </div>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.researchFacilities">
          <div class="checkbox-group">
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedEntrepreneurship" [binary]="true" inputId="cb-entrepreneurship" />
              <label for="cb-entrepreneurship" class="checkbox-label">Entrepreneurship</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedLabResearchCentres" [binary]="true" inputId="cb-lab" />
              <label for="cb-lab" class="checkbox-label">Lab & Research Centres</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedFundingForStudentProjects" [binary]="true" inputId="cb-funding" />
              <label for="cb-funding" class="checkbox-label">Funding for Student Projects</label>
            </div>
          </div>
          <div class="field mt-3">
            <label for="publications" class="filter-label">Publications per Year</label>
            <p-inputNumber [(ngModel)]="selectedPublicationsPerYear" inputId="publications" mode="decimal" 
              [showButtons]="true" [min]="0" styleClass="w-full" placeholder="Enter count" 
              [inputStyle]="{'font-size': '13px', 'padding': '8px'}"/>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full mt-3" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.alumni">
          <div class="checkbox-group">
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedInfluentialAlumni" [binary]="true" inputId="cb-influential" />
              <label for="cb-influential" class="checkbox-label">Influential Alumni</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedAlumniInLeadership" [binary]="true" inputId="cb-leadership" />
              <label for="cb-leadership" class="checkbox-label">Alumni in Leadership Roles</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedStartupFounders" [binary]="true" inputId="cb-startup-founders" />
              <label for="cb-startup-founders" class="checkbox-label">Startup Founders from College</label>
            </div>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.deadline">
          <div><label class="filter-label">Application Status</label>
            <p-dropdown [options]="applicationStatusOptions" [(ngModel)]="selectedApplicationStatus" styleClass="w-full"
              [showClear]="true" optionLabel="name" optionValue="value" placeholder="Select" appendTo="body" />
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

        <ng-container *ngIf="activeFilter === searchFilters.matchYourVibe">
          <div class="checkbox-group">
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedChill" [binary]="true" inputId="cb-chill" />
              <label for="cb-chill" class="checkbox-label">Chill</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedCompetitive" [binary]="true" inputId="cb-competitive" />
              <label for="cb-competitive" class="checkbox-label">Competitive</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedStartupVibe" [binary]="true" inputId="cb-startup-vibe" />
              <label for="cb-startup-vibe" class="checkbox-label">Startup Vibe</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedResearchVibe" [binary]="true" inputId="cb-research-vibe" />
              <label for="cb-research-vibe" class="checkbox-label">Research Vibe</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedCreative" [binary]="true" inputId="cb-creative" />
              <label for="cb-creative" class="checkbox-label">Creative</label>
            </div>
            <div class="checkbox-item">
              <p-checkbox [(ngModel)]="selectedTraditional" [binary]="true" inputId="cb-traditional" />
              <label for="cb-traditional" class="checkbox-label">Traditional</label>
            </div>
          </div>
          <p-button label="Apply" styleClass="submitBtn w-full" (onClick)="searchInstitutes()" />
        </ng-container>

      </div>
    </ng-container>
  </div>
</div>